// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
//axios
import axios from "axios";
axios.defaults.baseURL = 'http://webapi.xiaomifeng666.com/beeWeb';
Vue.prototype.$http = axios;
//vue中页面跳转， 显示在顶部
router.afterEach((to, from, next) => {
    window.scrollTo(0, 0)
})





/* 公共样式 */
import './assets/css/animate.min.css'
import './assets/css/global.css'
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js